import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-seguros',
  template: require('./seguros.component.html')
})
export class SegurosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/seguros/seguros.component.ts
 **/